export default function AboutMe() {
    return <div>
        <p>
            Hello! My name is Tommy Galletta. I am a recent Florida Tech graduated with a B.S. in Computer Science,
            seeking career opportunities in areas related to software development, game development, online media
            creation, entertainment, or performance.
        </p>
        <p>
            From a young age, I knew I had an interest in computers. I began playing games, such
            as <a href={"https://tomorrowcorporation.com/humanresourcemachine"}>Human Resource Machine</a>, that
            taught basic concepts of coding and algorithms, from elementary school. I spent a great deal of my free
            time in middle school learning concepts related to binary and the lowest-level computational circuits,
            eventually creating my own 8-bit computer from scratch in Minecraft. My desire to learn about computers
            has not diminished since, and I am looking to apply my passion to develop innovative projects.
        </p>
        <p>
            Beyond computers, my passions include playing piano and saxophone, singing, musical theatre,
            challenging video games, video creation and editing, Dungeons & Dragons, 3D modelling and 3D printing,
            and virtual reality.
        </p>
    </div>
}